<div
  class="prompt-group"
  [ngClass]="{ 'disabled': this.disabled() }"
>
  <input
    pInputText
    class="prompt-input"
    [ngClass]="{ 'disabled': this.disabled() }"
    (keyup)="onKey($event)"
    [(ngModel)]="this.promptInput"
    [placeholder]="this.getPlaceholder()"
    [disabled]="this.disabled()"
  >
  <p-button
    styleClass="prompt-send-button"
    severity="primary"
    [disabled]="this.disabled() || !this.promptInput.trim()"
    (onClick)="this.sendPrompt()"
  >
    <ng-template pTemplate="content">
      <i [ngClass]="{
                'ri-arrow-up-line': promptInput.trim().length >= 0,
                'ri-send-plane-2-fill': promptInput.trim().length === 0
              }"></i>
    </ng-template>
  </p-button>
</div>